import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { ConditionalBlockView } from "./ConditionalBlockView";
import { ConditionalOperator } from "../utils/conditionalSerializer";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    conditionalBlock: {
      insertConditionalBlock: (attrs: {
        condition: string;
        operator: ConditionalOperator;
        value?: string | null;
        conditionTitle?: string | null;
      }) => ReturnType;
    };
  }
}

export const ConditionalBlock = Node.create({
  name: "conditionalBlock",

  group: "block",
  content: "block+",
  defining: true,
  isolating: true,

  addAttributes() {
    return {
      condition: {
        default: null,
        parseHTML: element => element.getAttribute("condition"),
        renderHTML: attributes => ({ condition: attributes.condition })
      },
      operator: {
        default: "truthy",
        parseHTML: element => element.getAttribute("operator"),
        renderHTML: attributes => ({ operator: attributes.operator })
      },
      value: {
        default: null,
        parseHTML: element => element.getAttribute("value"),
        renderHTML: attributes =>
          attributes.value !== null && attributes.value !== undefined
            ? { value: attributes.value }
            : {}
      },
      // Store the human-readable field title for display
      conditionTitle: {
        default: null,
        parseHTML: element => element.getAttribute("condition-title"),
        renderHTML: attributes =>
          attributes.conditionTitle ? { "condition-title": attributes.conditionTitle } : {}
      }
    };
  },

  parseHTML() {
    return [{ tag: "div[data-conditional-block]" }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, { "data-conditional-block": true }),
      0
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(ConditionalBlockView);
  },

  // @ts-ignore
  addCommands() {
    return {
      insertConditionalBlock:
        (attrs: { condition: string; operator: ConditionalOperator; value?: string | null; conditionTitle?: string }) =>
        ({ commands }: any) => {
          return commands.insertContent({
            type: this.name,
            attrs,
            content: [{ type: "paragraph" }]
          });
        }
    };
  }
});
